import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '../../img/QRCode.png';
const _hoisted_1 = {
  class: "sevenpageButton"
};
const _hoisted_2 = {
  class: "topBox"
};
const _hoisted_3 = {
  class: "box"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
import { reactive, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { treeCatalogueSelectConfig } from "../../api/home";
export default {
  __name: 'navigationbar',
  setup(__props) {
    const data = reactive({
      getMessageList: []
    });
    const route = useRoute();
    const router = useRouter();
    const detailedBtn = () => {
      localStorage.setItem("headId", 4);
      router.push({
        path: "/contactUs"
      });
    };

    // 查询基础信息
    const getMessageBtn = () => {
      treeCatalogueSelectConfig().then(res => {
        if (res && res.data) {
          data.getMessageList = res.data;
        }
        console.log(res);
      });
    };
    const clickItem = (index, id) => {
      localStorage.setItem("headId", index);
      localStorage.setItem("headValueId", id);
      if (id == '1987831222629982210') {
        router.push({
          path: "/"
        });
      } else if (id == '1988426439470223361') {
        router.push({
          path: "/About"
        });
      } else {
        router.push({
          path: "/medium",
          query: {
            userId: id
          }
        });
      }
    };
    const clickBtn = (finalId, id) => {
      console.log(finalId, id, "77777");
      router.push({
        path: "/medium",
        query: {
          ids: id,
          userId: finalId
        }
      });
    };
    onMounted(() => {
      // 代码逻辑0
      getMessageBtn();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.getMessageList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "title",
          key: index
        }, [_createElementVNode("div", {
          class: "named",
          onClick: $event => clickItem(index, item.id)
        }, _toDisplayString(item.name), 9, _hoisted_4), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (items, indexs) => {
          return _openBlock(), _createElementBlock("div", {
            class: "name",
            key: indexs,
            onClick: $event => clickBtn(items.finalId, items.id)
          }, _toDisplayString(items.name), 9, _hoisted_5);
        }), 128))]);
      }), 128))]), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "detailedBox"
      }, [_createElementVNode("div", {
        class: "follow"
      }, "关注我们"), _createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }), _createElementVNode("div", {
        class: "names"
      }, "协会官方微信")], -1))]), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "bottonBox"
      }, [_createElementVNode("div", {
        class: ""
      }, "地址：浙江省杭州市滨江区六和路309号中控科技园E1705 电话：0571-86538535/86538511 传真：0571-86538500"), _createElementVNode("div", {
        class: ""
      }, [_createTextVNode("(c)2025 版权所有：浙江省仪器仪表行业协会 "), _createElementVNode("a", {
        href: "https://beian.miit.gov.cn",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "浙ICP备05002928号-4"), _createTextVNode(" 公安备案号：1925793824用597")])], -1))]);
    };
  }
};